import { useEffect } from "react";
import { toast, type Id } from "react-toastify";
import type { RefObject } from "react";

export const useToastCleanup = (toastRef: RefObject<Id | undefined>) => {
  useEffect(
    () => () => {
      toast.dismiss(toastRef.current);
    },
    [toastRef],
  );
};
